import { render, staticRenderFns } from "./ReturnData.vue?vue&type=template&id=3da624f5&scoped=true"
import script from "./ReturnData.vue?vue&type=script&lang=ts"
export * from "./ReturnData.vue?vue&type=script&lang=ts"
import style0 from "./ReturnData.vue?vue&type=style&index=0&id=3da624f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da624f5",
  null
  
)

export default component.exports